export const MULTI_SELECT_RIGHTS_SCOPE_SHELL_KEYS = [
  "Rights Scope",
  "Benefiting Axis",
  "Contributing Axis",
] as const;

export type MultiSelectRightsScopeShellKey =
  (typeof MULTI_SELECT_RIGHTS_SCOPE_SHELL_KEYS)[number];
